import { render, staticRenderFns } from "./BasicInputText.vue?vue&type=template&id=3ce30a35&"
import script from "./BasicInputText.vue?vue&type=script&lang=js&"
export * from "./BasicInputText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports